export default "__VITE_ASSET__D9f7duLw__"